import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.scss";
import { useNavigate } from "react-router-dom";
import Logo from "../../../common/BrandLogo";
import { bootIntercom } from "../../../../util/intercom";
import { useStoreActions } from "easy-peasy";
import { brand } from "../../../../config/brands";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  console.log(isDropdownOpen);
  const setFilterData = useStoreActions((actions) => actions.setFilterData);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeDropdown = () => setIsDropdownOpen(false);
  const handleNavClick = () => {
    closeDropdown();
    setIsMenuOpen(false);
  };

  useEffect(() => {
    bootIntercom();
  }, []);

  const handleOrthoCheckClick = () => {
    localStorage.removeItem("provider_api_key");
    localStorage.removeItem("schedulers_customer_config");
    localStorage.removeItem("orthocheck_ai_initiate");
    localStorage.removeItem("orthocheck_initiate");
    localStorage.removeItem("orthocheck_results");
    localStorage.removeItem("provider_enhanced");
    localStorage.removeItem("provider_info");
    handleNavClick();
  };

  return (
    <header className="header">
      <div className="header-content">
        {/* Logo */}
        <div className="logo">
          <div className="logo-icon">
            <Link to="/" onClick={handleOrthoCheckClick}>
              <Logo viewBox="0 0 143 48" width="140px" height="46.9844px" />
              {/* <img src={MOPLOGO} alt="MOP Logo" style={{ cursor: "pointer" }} /> */}
            </Link>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="desktop-nav">
          <ul>
            <li>
              <Link
                to={`/providers`}
                className={
                  location.pathname === "/providers" ||
                  /^\/[^/]+\/[^/]+\/\d+$/.test(location.pathname)
                    ? "active-link"
                    : ""
                }
                onClick={() => {
                  localStorage.removeItem("provider_api_key");
                  localStorage.removeItem("schedulers_customer_config");
                  sessionStorage.setItem("providerPage", "1");
                  sessionStorage.removeItem("providerViewed");
                  setFilterData({});
                }}
              >
                Find a Provider
              </Link>
            </li>
            <li>
              <a href={`${brand.webUrl}${brand.educationPath}`}>
                Education Library
              </a>
            </li>
            {brand.key !== "mdp" && (
              <li>
                <a href={`${brand.webUrl}/for-providers`}>For Providers</a>
              </li>
            )}
            <li>
              <a href={`${brand.webUrl}/blog`}>Blog</a>
            </li>
          </ul>
        </nav>

        {/* CTA Desktop */}
        <div
          className="cta-section"
          onClick={() => {
            handleOrthoCheckClick();
            navigate(`${brand.checkerPath}?telehealth=true`);
          }}
        >
          <button className="provider-signup-btn">
            Try {brand.checkerName} free
          </button>
        </div>

        {/* Mobile Actions */}
        <div className="mobile-actions">
          <button className="mobile-menu-btn" onClick={toggleMenu}>
            {isMenuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M3 12H21M3 6H21M3 18H21"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <div className="mobile-menu-content">
          <nav className="mobile-nav">
            <ul>
              {/* <li key="orthocheck">
                <Link
                  to="/orthocheck"
                  onClick={handleOrthoCheckClick}
                  className={
                    location.pathname === "/orthocheck" ||
                      location.pathname.startsWith("/orthocheck/")
                      ? "active-link"
                      : ""
                  }
                >
                  OrthoCheck
                </Link>
              </li> */}
              <li key="find-provider">
                <Link
                  to="/providers"
                  onClick={() => {
                    localStorage.removeItem("provider_api_key");
                    localStorage.removeItem("schedulers_customer_config");
                    sessionStorage.setItem("providerPage", "1");
                    sessionStorage.removeItem("providerViewed");
                    handleNavClick();
                  }}
                  className={
                    location.pathname === "/providers" ||
                    /^\/[^/]+\/[^/]+\/\d+$/.test(location.pathname)
                      ? "active-link"
                      : ""
                  }
                >
                  Find a Provider
                </Link>
              </li>
              <li key="educational-library">
                <a href={`${brand.webUrl}${brand.educationPath}`}>
                  Education Library
                </a>
              </li>
              {brand.key !== "mdp" && (
                <li key="for-providers">
                  <a href={`${brand.webUrl}/for-providers`}>For providers</a>
                </li>
              )}
              <li>
                <a href={`${brand.webUrl}/blog`}>Blog</a>
              </li>
              <li key="provider-signup">
                <Link
                  to={`${brand.checkerPath}?telehealth=true`}
                  onClick={() => {
                    handleOrthoCheckClick();
                    navigate(`${brand.checkerPath}?telehealth=true`);
                  }}
                >
                  Try {brand.checkerName} free
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
